import {
  subclass,
  property,
} from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import {
  messageBundle,
  storeNode,
  tsx,
} from "@arcgis/core/widgets/support/widget";

import "./FeaturedArticle/FeaturedArticle.scss";

import AppT9N from "../../t9n/App/App.json";
import NavBarViewModel from "./NavBar/NavBarViewModel";

import { VNode } from "src/interfaces/interfaces";

import ChartViewerTitlePic from "../../../public/assets/featuredArticle/chartViewerArticle/chartViewerHeaderPic.png";
import selectionGIF from "../../../public/assets/featuredArticle/chartViewerArticle/selectiongif.gif";
import museumExamplePic from "../../../public/assets/featuredArticle/chartViewerArticle/museumExample.png";

import SidebarTitlePic from "../../../public/assets/featuredArticle/sidebarArticle/sidebarTitlePic.png";
import basemapGalGIF from "../../../public/assets/featuredArticle/sidebarArticle/basemapGal.gif";
import BMG_JPG from "../../../public/assets/featuredArticle/sidebarArticle/BMG.jpg";
import utilNetPNG from "../../../public/assets/featuredArticle/sidebarArticle/UtilNet.png";
import lyrlistPNG from "../../../public/assets/featuredArticle/sidebarArticle/lyrlist.png";
import editGIF from "../../../public/assets/featuredArticle/sidebarArticle/Edit.gif";
import themecompGIF from "../../../public/assets/featuredArticle/sidebarArticle/themecomp.gif";
import aa_measureJPG from "../../../public/assets/featuredArticle/sidebarArticle/aa_measure.jpg";

import ThemingTitlePic from "../../../public/assets/featuredArticle/themingArticle/ThemingArticleHeaderPic.jpg";
import themingPic_1 from "../../../public/assets/featuredArticle/themingArticle/Picture1.png";
import themingPic_2 from "../../../public/assets/featuredArticle/themingArticle/Picture2.png";
import themingPic_3 from "../../../public/assets/featuredArticle/themingArticle/Picture3.jpg";
import themingPic_4 from "../../../public/assets/featuredArticle/themingArticle/Picture4.jpg";
import themingPic_5 from "../../../public/assets/featuredArticle/themingArticle/Picture5.png";
import themingPic_6 from "../../../public/assets/featuredArticle/themingArticle/Picture6.jpg";
import themingPic_7 from "../../../public/assets/featuredArticle/themingArticle/Picture7.jpg";
import themingPic_8 from "../../../public/assets/featuredArticle/themingArticle/Picture8.png";
import themingPic_9 from "../../../public/assets/featuredArticle/themingArticle/Picture9.png";
import themingPic_10 from "../../../public/assets/featuredArticle/themingArticle/Picture10.png";
import themingPic_11 from "../../../public/assets/featuredArticle/themingArticle/Picture11.png";
import themingPic_12 from "../../../public/assets/featuredArticle/themingArticle/Picture12.png";
import themingPic_13 from "../../../public/assets/featuredArticle/themingArticle/Picture13.png";
import themingPic_14 from "../../../public/assets/featuredArticle/themingArticle/Picture14.png";

import InsetsTitlePic from "../../../public/assets/featuredArticle/insetsArticle/insetsArticleHeaderPic.jpg";
import insets_Pic1 from "../../../public/assets/featuredArticle/insetsArticle/insets1.png";
import insets_Pic2 from "../../../public/assets/featuredArticle/insetsArticle/insets2.png";
import insets_Pic3 from "../../../public/assets/featuredArticle/insetsArticle/insets3.png";
import insets_Pic4 from "../../../public/assets/featuredArticle/insetsArticle/insets4.png";
import insets_Pic5 from "../../../public/assets/featuredArticle/insetsArticle/insets5.png";
import insets_Pic6 from "../../../public/assets/featuredArticle/insetsArticle/insets6.png";
import insets_Pic7 from "../../../public/assets/featuredArticle/insetsArticle/insets7.png";
import insets_Pic8 from "../../../public/assets/featuredArticle/insetsArticle/insets8.png";
import insets_Pic9 from "../../../public/assets/featuredArticle/insetsArticle/insets9.png";
import insets_Pic10 from "../../../public/assets/featuredArticle/insetsArticle/insets10.png";
import insets_Pic11 from "../../../public/assets/featuredArticle/insetsArticle/insets11.png";
import insets_Pic12 from "../../../public/assets/featuredArticle/insetsArticle/insets12.png";
import insets_Pic13 from "../../../public/assets/featuredArticle/insetsArticle/insets13.png";
import insets_Pic14 from "../../../public/assets/featuredArticle/insetsArticle/insets14.png";
import insets_Pic14_1 from "../../../public/assets/featuredArticle/insetsArticle/insets14_1.png";
import insets_Pic14_1_1 from "../../../public/assets/featuredArticle/insetsArticle/insets14_1_1.png";
import insets_Pic14_1_2 from "../../../public/assets/featuredArticle/insetsArticle/insets14_1_2.png";
import insets_Pic15 from "../../../public/assets/featuredArticle/insetsArticle/insets15.png";
import insets_Pic16 from "../../../public/assets/featuredArticle/insetsArticle/insets16.png";
import insets_Pic17 from "../../../public/assets/featuredArticle/insetsArticle/insets17.png";

import AtlasTitlePic from "../../../public/assets/featuredArticle/atlasArticle/atlasHeaderPic.png";
import atlas_Pic1 from "../../../public/assets/featuredArticle/atlasArticle/01_App.png";
import atlas_Pic2 from "../../../public/assets/featuredArticle/atlasArticle/02_OpenMap.png";
import atlas_Pic3 from "../../../public/assets/featuredArticle/atlasArticle/03_AddLayers.png";
import atlas_Pic4 from "../../../public/assets/featuredArticle/atlasArticle/04_MapLayers.png";
import atlas_Pic5 from "../../../public/assets/featuredArticle/atlasArticle/05_3DMeaure.png";
import atlas_Pic6 from "../../../public/assets/featuredArticle/atlasArticle/06_Sketch.png";
import atlas_Pic7 from "../../../public/assets/featuredArticle/atlasArticle/07_ElevationProfile.png";
import atlas_Pic8 from "../../../public/assets/featuredArticle/atlasArticle/08_SaveMap.png";

import ManagerTitlePic from "../../../public/assets/featuredArticle/managerArticle/managerHeaderPic.png";
import manager_Pic1 from "../../../public/assets/featuredArticle/managerArticle/Manager1.png";
import manager_Pic2 from "../../../public/assets/featuredArticle/managerArticle/Manager2.png";
import manager_Pic3 from "../../../public/assets/featuredArticle/managerArticle/Manager3.png";
import manager_Pic4 from "../../../public/assets/featuredArticle/managerArticle/Manager4.png";
import manager_Pic5 from "../../../public/assets/featuredArticle/managerArticle/Manager5.png";
import manager_Pic6 from "../../../public/assets/featuredArticle/managerArticle/Manager6.png";

import ReporterTitlePic from "../../../public/assets/featuredArticle/reporterArticle/reporterHeaderPic.png";
import reporter_Pic1 from "../../../public/assets/featuredArticle/reporterArticle/Reporter1.png";
import reporter_Pic2 from "../../../public/assets/featuredArticle/reporterArticle/Reporter2.png";
import reporter_Pic3 from "../../../public/assets/featuredArticle/reporterArticle/Reporter3.png";
import reporter_Pic4 from "../../../public/assets/featuredArticle/reporterArticle/Reporter4.png";
import reporter_Pic5 from "../../../public/assets/featuredArticle/reporterArticle/Reporter5.png";

import LanguageSwitcherTitlePic from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcherArticleHeaderPic.png";
import langSwitcher_Pic1 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher1.png";
import langSwitcher_Pic2 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher2.png";
import langSwitcher_Pic3 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher3.png";
import langSwitcher_Pic4 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher4.png";
import langSwitcher_Pic5 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher5.png";
import langSwitcher_Pic6 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher6.png";
import langSwitcher_Pic7 from "../../../public/assets/featuredArticle/languageSwitcherArticle/langSwitcher7.png";

import CompareTitlePic from "../../../public/assets/featuredArticle/compareArticle/CompareArticleHeaderPic.png";
import compare_Pic1 from "../../../public/assets/featuredArticle/compareArticle/Compare1.jpg";
import compare_Pic2 from "../../../public/assets/featuredArticle/compareArticle/Compare2.png";
import compare_Pic3 from "../../../public/assets/featuredArticle/compareArticle/Compare3.png";
import compare_Pic4 from "../../../public/assets/featuredArticle/compareArticle/Compare4.png";
import compare_Pic5 from "../../../public/assets/featuredArticle/compareArticle/Compare5.png";
import compare_Pic6 from "../../../public/assets/featuredArticle/compareArticle/Compare6.png";
import compare_Pic7 from "../../../public/assets/featuredArticle/compareArticle/Compare7.png";
import compare_Pic8 from "../../../public/assets/featuredArticle/compareArticle/Compare8.png";
import compare_Pic9 from "../../../public/assets/featuredArticle/compareArticle/Compare9.png";
import compare_Pic10 from "../../../public/assets/featuredArticle/compareArticle/Compare10.png";
import compare_Pic11 from "../../../public/assets/featuredArticle/compareArticle/Compare11.png";
import compare_Pic12 from "../../../public/assets/featuredArticle/compareArticle/Compare12.jpg";
import compare_Pic13 from "../../../public/assets/featuredArticle/compareArticle/Compare13.png";
import compare_Pic14 from "../../../public/assets/featuredArticle/compareArticle/Compare14.png";
import compare_Pic15 from "../../../public/assets/featuredArticle/compareArticle/Compare15.png";
import compare_Pic16 from "../../../public/assets/featuredArticle/compareArticle/Compare16.png";
import compare_Pic17 from "../../../public/assets/featuredArticle/compareArticle/Compare17.jpg";

import Sanitizer from "@esri/arcgis-html-sanitizer";

/**
 * Ideas:
 * - Could rework FeaturedArticle formatting with this CSS Grid implementation: https://www.joshwcomeau.com/css/full-bleed/
 */
@subclass("app.ui.FeaturedArticle")
export default class FeaturedArticle extends Widget {
  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  @property()
  carouselToggle: boolean = true;

  @property()
  navbarVM: NavBarViewModel;

  @property()
  _articleContainer: HTMLDivElement;

  _sanitizer = new Sanitizer();

  constructor(args) {
    super(args);
  }

  postInitialize() {
    this.navbarVM.watch("_featuredArticleStateRouter", () => {
      if (this._articleContainer != null) {
        this._articleContainer.scrollTop = 0;
      }
    });
  }

  render() {
    return (
      <div
        class="featured-article"
        bind={this}
        afterCreate={storeNode}
        data-node-ref="_articleContainer"
      >
        {this._renderCarouselRouter()}
      </div>
    );
  }

  private _renderCarouselRouter() {
    switch (this.navbarVM._featuredArticleStateRouter) {
      case "chartViewer":
        return this._renderChartViewer();
      case "sidebar":
        return this._renderSidebar();
      case "theming":
        return this._renderTheming();
      case "insets":
        return this._renderInsets();
      case "atlas":
        return this._renderAtlas();
      case "manager":
        return this._renderManager();
      case "reporter":
        return this._renderReporter();
      case "languageSwitcher":
        return this._renderLanguageSwitcher();
      default:
        return this._renderCompare();
    }
  }

  private _renderChartViewer(): VNode[] {
    const {
      part3,
      part4,
      part5,
      part6,
      part6_1,
      part6_2,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
      part23,
      part24,
      imgAlt1,
      imgAlt2,
      imgAlt3,
      imgAlt4,
      imgAlt5,
      imgAlt6,
      imgAlt7,
    } = this.appMessages.featuredArticle;

    const { chartViewerArticle } = this.appMessages.featuredTab;
    return [
      <img
        key="header-img-chart-viewer"
        id="header-img"
        src={ChartViewerTitlePic}
        alt=""
      />,

      <div key="article-content-chart-viewer" class="article-content">
        <header id="article-header">{chartViewerArticle}</header>

        <p>
          {part3}&nbsp;
          <a
            href="https://www.arcgis.com/home/item.html?id=be4582b38d764de0a970b986c824acde"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            {chartViewerArticle}
          </a>
          &nbsp;{part4}&nbsp;
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=5daaae106f774b95bc749dbe1b90a964"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            {part5}
          </a>
          &nbsp;{part6}
        </p>
        <div class="newsr-image_content oversized-picture">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/3charts.png"
            alt={imgAlt1}
            title={imgAlt1}
          />
        </div>

        <br />

        <p>{part6_1}</p>

        <div class="newsr-image_content oversized-picture">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/chartviewersidebyside.png"
            alt={`${chartViewerArticle} Instant App ${imgAlt2}`}
            title={`${chartViewerArticle} Instant App ${imgAlt2}`}
          />
        </div>

        <br />

        <p>{part6_2}</p>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/switch-layers.png"
            alt={imgAlt5}
            title={imgAlt5}
          />
        </div>

        <p>&nbsp;</p>
        <h2></h2>
        <h2>
          {chartViewerArticle} {part7}
        </h2>

        <p>
          {part8}&nbsp;
          <a
            href="https://www.esri.com/arcgis-blog/products/arcgis-online/analytics/introducing-charts-in-map-viewer/"
            target="_blank"
          >
            {part9}
          </a>
          &nbsp;{part10}
        </p>

        <p>{part11}</p>

        <ul>
          <li>{part12}</li>
          <li>{part13}</li>
        </ul>

        <div class="newsr-image_content oversized-picture">
          <img
            class="newsr-image_src"
            src={selectionGIF}
            alt={imgAlt4}
            title={imgAlt4}
          />
        </div>

        <ul>
          <li>{part14}</li>
        </ul>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/chartconfig.png"
            alt={imgAlt3}
            title={imgAlt3}
          />
        </div>

        <ul>
          <li>{part16}</li>
          <li>{part17}</li>
          <li>{part18}</li>
        </ul>
        <p>&nbsp;</p>
        <h2></h2>
        <h2>{part19}</h2>
        <p>
          {part20}&nbsp;
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=148f5599241c4795a1ef8170a4581953"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            7,000+ {part21}
          </a>
          &nbsp;{part22}
        </p>

        <div class="newsr-image_content oversized-picture">
          <img
            class="newsr-image_src"
            src={museumExamplePic}
            alt={`${chartViewerArticle} ${imgAlt6}`}
            title={`${chartViewerArticle} ${imgAlt6}`}
          />
        </div>
        <p>
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=87255383148143a9b1b77c25f5cb32f0"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            {part23}
          </a>
          &nbsp;{part24}
        </p>

        <div class="newsr-image_content oversized-picture">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/generation.png"
            alt={`${chartViewerArticle} ${imgAlt7}`}
            title={`${chartViewerArticle} ${imgAlt7}`}
          />
        </div>
      </div>,
    ];
  }

  private _renderSidebar(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
    } = this.appMessages.featureArticle_Sidebar;

    return [
      <img
        key="header-img-sidebar"
        id="header-img"
        src={SidebarTitlePic}
        alt=""
      />,

      <div key="article-content-sidebar" class="article-content">
        <header id="article-header">{part1}</header>
        <p>{part2}</p>
        <p>
          <i innerHTML={this._sanitizer.sanitize(part3)}></i>
        </p>
        <p>&nbsp;</p>
        <h2></h2>
        <h2>{part4}</h2>
        <p>{part5}</p>
        <p>{part6}</p>
        <ul>
          <li innerHTML={this._sanitizer.sanitize(part7)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={lyrlistPNG}
                alt="Layer list example with layer picker"
                title="Layer list example with layer picker"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part8)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={basemapGalGIF}
                alt="Basemap gallery configuration"
                title="Basemap gallery configuration"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>

          <li innerHTML={this._sanitizer.sanitize(part9)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={editGIF}
                alt="Editing example using the snapping feature"
                title="Editing example using the snapping feature"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part10)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={utilNetPNG}
                alt="Utility network trace tool example"
                title="Utility network trace tool example"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
        </ul>

        <h2></h2>
        <h2>{part11}</h2>

        <p>{part12}</p>

        <p>{part13}</p>

        <ul>
          <li innerHTML={this._sanitizer.sanitize(part14)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={aa_measureJPG}
                alt="Measure tool example in app"
                title="Measure tool example in app"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part15)}></li>
          <li innerHTML={this._sanitizer.sanitize(part16)}></li>
          <li innerHTML={this._sanitizer.sanitize(part17)}></li>
          <li innerHTML={this._sanitizer.sanitize(part18)}></li>
        </ul>

        <h2></h2>
        <h2>{part19}</h2>

        <p>{part20}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src"
              src={themecompGIF}
              alt="Choosing a new theme in the theme component"
              title="Choosing a new theme in the theme component"
            />
          </div>
          <figcaption class="newsr-image_caption"></figcaption>
        </figure>
      </div>,
    ];
  }

  private _renderTheming(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
      part23,
      part24,
      part25,
      part26,
      part27,
      part28,
      part29,
      part30,
      part31,
      part32,
      part33,
      part34,
      part35,
      part36,
      part37,
      part38,
      part39,
      part40,
      part41,
      part42,
      part43,
      part44,
      part45,
    } = this?.appMessages?.featureArticle_Theming || {};
    return [
      <img
        key="header-img-theming"
        id="header-img"
        src={ThemingTitlePic}
        alt=""
      />,

      <div key="article-content-theming" class="article-content">
        <header id="article-header">{part1}</header>
        <p
          innerHTML={
            this._sanitizer.sanitize(part2) +
            " " +
            this._sanitizer.sanitize(part3)
          }
        ></p>
        <h2></h2>
        <h2>{part4}</h2>
        <p>{part5}</p>
        <h2>{part6}</h2>
        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part7)}></li>
          <li innerHTML={this._sanitizer.sanitize(part8)}></li>
          <li innerHTML={this._sanitizer.sanitize(part9)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10)}></li>
          <li innerHTML={this._sanitizer.sanitize(part11)}></li>
        </ul>

        <p>{part12}</p>

        <h2>{part13}</h2>

        <p>{part14}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_1}
              alt={part15}
              title={part15}
            />
          </div>
          <figcaption class="newsr-image_caption">{part15}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part16}</h2>

        <p>{part17}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_2}
              alt={part18}
              title={part18}
            />
          </div>
          <figcaption class="newsr-image_caption">{part18}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part19}</h2>

        <p>{part20}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_3}
              alt={part21}
              title={part21}
            />
          </div>
          <figcaption class="newsr-image_caption">{part21}</figcaption>
        </figure>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_4}
              alt={part22}
              title={part22}
            />
          </div>
          <figcaption class="newsr-image_caption">{part22}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part23}</h2>

        <p>{part24}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_5}
              alt={part25}
              title={part25}
            />
          </div>
          <figcaption class="newsr-image_caption">{part25}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part26}</h2>

        <p>{part27}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_6}
              alt={part28}
              title={part28}
            />
          </div>
          <figcaption class="newsr-image_caption">{part28}</figcaption>
        </figure>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_7}
              alt={part29}
              title={part29}
            />
          </div>
          <figcaption class="newsr-image_caption">{part29}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part30}</h2>

        <p innerHTML={this._sanitizer.sanitize(part31)}></p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_8}
              alt={part32}
              title={part32}
            />
          </div>
          <figcaption class="newsr-image_caption">{part32}</figcaption>
        </figure>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_9}
              alt={part33}
              title={part33}
            />
          </div>
          <figcaption class="newsr-image_caption">{part33}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part34}</h2>

        <p>{part35}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_10}
              alt={part36}
              title={part36}
            />
          </div>
          <figcaption class="newsr-image_caption">{part36}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part37}</h2>

        <p>{part38}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_11}
              alt={part39}
              title={part39}
            />
          </div>
          <figcaption class="newsr-image_caption">{part39}</figcaption>
        </figure>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_12}
              alt={part40}
              title={part40}
            />
          </div>
          <figcaption class="newsr-image_caption">{part40}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part41}</h2>

        <p>{part42}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_13}
              alt={part43}
              title={part43}
            />
          </div>
          <figcaption class="newsr-image_caption">{part43}</figcaption>
        </figure>

        <h2></h2>
        <h2>{part44}</h2>

        <p>{part45}</p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src theming-image"
              src={themingPic_14}
              alt={""}
              title={""}
            />
          </div>
          <figcaption class="newsr-image_caption">{""}</figcaption>
        </figure>
      </div>,
    ];
  }

  private _renderInsets(): VNode[] {
    const {
      part1,
      part2,
      part6,
      part7,
      part8,
      part9,
      part10,
      part13,
      part14,
      part17,
      part20,
      part23,
      part24,
      part27,
      part28,
      part35,
      part38,
      part39,
      part40,
      part41,
      part41_1,
      part41_1_1,
      part41_1_2,
      part41_2,
      part42,
      part43,
      part44,
      part45,
      part46,
      part47,
      part48,
      part49,
      part50,
      part51,
    } = this?.appMessages?.featureArticle_Insets || {};
    return [
      <img
        key="header-img-insets"
        id="header-img"
        src={InsetsTitlePic}
        alt=""
      />,

      <div key="article-content-insets" class="article-content">
        <header id="article-header">{part1}</header>

        {[
          {
            type: "paragraph",
            content: part2,
          },
          {
            type: "heading",
            content: part6,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}

        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part7)}></li>
          {this._renderPic(insets_Pic1)}
          <li innerHTML={this._sanitizer.sanitize(part8)}></li>
          {this._renderPic(insets_Pic2)}
          <li innerHTML={this._sanitizer.sanitize(part9)}></li>
          {this._renderPic(insets_Pic3)}
          <li innerHTML={this._sanitizer.sanitize(part10)}></li>
          {this._renderPic(insets_Pic4)}
        </ul>

        {[
          {
            type: "heading",
            content: part13,
          },
          {
            type: "paragraph",
            content: part14,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic5,
          },
          {
            type: "paragraph",
            content: part17,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic6,
          },
          {
            type: "paragraph",
            content: part20,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic7,
          },
          {
            type: "heading",
            content: part23,
          },
          {
            type: "paragraph",
            content: part24,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic8,
          },
          {
            type: "paragraph",
            content: part27,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic9,
          },
          {
            type: "paragraph",
            content: part28,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic10,
          },
          {
            type: "paragraph",
            content: part35,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic11,
          },
          {
            type: "paragraph",
            content: part38,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic12,
          },
          {
            type: "heading",
            content: part39,
          },
          {
            type: "paragraph",
            content: part40,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic13,
          },
          {
            type: "paragraph",
            content: part41,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic14,
          },
          {
            type: "paragraph",
            content: part41_1,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic14_1,
          },
          {
            type: "paragraph",
            content: part41_1_1,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic14_1_1,
          },
          {
            type: "paragraph",
            content: part41_1_2,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic14_1_2,
          },
          {
            type: "paragraph",
            content: part41_2,
          },
          {
            type: "paragraph",
            content: part42,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic15,
          },
          {
            type: "paragraph",
            content: part43,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic16,
          },
          {
            type: "paragraph",
            content: part44,
          },
          {
            type: "image",
            content: null,
            url: insets_Pic17,
          },
          {
            type: "heading",
            content: part45,
          },
          {
            type: "paragraph",
            content: part46,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}

        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part47)}></li>
          <li innerHTML={this._sanitizer.sanitize(part48)}></li>
          <li innerHTML={this._sanitizer.sanitize(part49)}></li>
          <li innerHTML={this._sanitizer.sanitize(part50)}></li>
        </ul>

        {[
          {
            type: "paragraph",
            content: part51,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
      </div>,
    ];
  }

  private _renderAtlas(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
    } = this?.appMessages?.featureArticle_Atlas || {};
    return [
      <img key="header-img-atlas" id="header-img" src={AtlasTitlePic} alt="" />,

      <div key="article-content-atlas" class="article-content">
        <header id="article-header">{part1}</header>

        {[
          {
            type: "paragraph",
            content: part2,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic1,
          },
          {
            type: "heading",
            content: part3,
          },
          {
            type: "paragraph",
            content: part4,
          },
          {
            type: "heading",
            content: part5,
          },
          {
            type: "paragraph",
            content: part6,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic2,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic3,
          },
          {
            type: "paragraph",
            content: part7,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic4,
          },
          {
            type: "paragraph",
            content: part8,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic5,
          },
          {
            type: "paragraph",
            content: part9,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic6,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic7,
          },
          {
            type: "paragraph",
            content: part10,
          },
          {
            type: "heading",
            content: part11,
          },
          {
            type: "paragraph",
            content: part12,
          },
          {
            type: "image",
            content: null,
            url: atlas_Pic8,
          },
          {
            type: "heading",
            content: part13,
          },
          {
            type: "paragraph",
            content: part14,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
      </div>,
    ];
  }

  private _renderManager(): VNode[] {
    const {
      part1,
      part2,
      picture1,
      part3,
      part4,
      picture2,
      part5,
      part7_0,
      part7_1,
      part7_2,
      part7_3,
      part7_4,
      part7_5,
      part7_6,
      picture3,
      part8,
      part9,
      part10_0,
      part10_1,
      part10_2,
      part10_3,
      part10_4,
      part10_5,
      part10_6,
      part10_7,
      part10_8,
      picture4,
      part11,
      part12,
      picture5,
      part13,
      picture6,
    } = this?.appMessages?.featureArticle_Manager || {};
    return [
      <img
        key="header-img-manager"
        id="header-img"
        src={ManagerTitlePic}
        alt=""
      />,

      <div key="article-content-manager" class="article-content">
        <header id="article-header">{part1}</header>

        {[
          {
            type: "paragraph",
            content: part2,
          },
          {
            type: "image",
            content: picture1,
            url: manager_Pic1,
            useAsCaption: false,
          },
          {
            type: "heading",
            content: part3,
          },
          {
            type: "paragraph",
            content: part4,
          },
          {
            type: "image",
            content: picture2,
            url: manager_Pic2,
            useAsCaption: false,
          },
          {
            type: "paragraph",
            content: part5,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}

        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part7_0)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_1)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_2)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_3)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_4)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_5)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7_6)}></li>
        </ul>
        {[
          {
            type: "image",
            content: picture3,
            url: manager_Pic3,
            useAsCaption: false,
          },
          {
            type: "heading",
            content: part8,
          },
          {
            type: "paragraph",
            content: part9,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}

        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part10_0)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_1)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_2)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_3)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_4)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_5)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_6)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_7)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10_8)}></li>
        </ul>
        {[
          {
            type: "image",
            content: picture4,
            url: manager_Pic4,
            useAsCaption: false,
          },
          {
            type: "heading",
            content: part11,
          },
          {
            type: "paragraph",
            content: part12,
          },
          {
            type: "image",
            content: picture5,
            url: manager_Pic5,
            useAsCaption: false,
          },
          {
            type: "paragraph",
            content: part13,
          },
          {
            type: "image",
            content: picture6,
            url: manager_Pic6,
            useAsCaption: false,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
      </div>,
    ];
  }

  private _renderReporter(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
      part23,
      part24,
      part25,
      part26,
    } = this?.appMessages?.featureArticle_Reporter || {};
    return [
      <img
        key="header-img-reporter"
        id="header-img"
        src={ReporterTitlePic}
        alt=""
      />,

      <div key="article-content-reporter" class="article-content">
        <header id="article-header">{part1}</header>
        {[
          {
            type: "paragraph",
            content: part2,
          },

          {
            type: "heading",
            content: part3,
          },
          {
            type: "paragraph",
            content: part4,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part5)}></li>
          <li innerHTML={this._sanitizer.sanitize(part6)}></li>
          <li innerHTML={this._sanitizer.sanitize(part7)}></li>
          <li innerHTML={this._sanitizer.sanitize(part8)}></li>
          <li innerHTML={this._sanitizer.sanitize(part9)}></li>
          <li innerHTML={this._sanitizer.sanitize(part10)}></li>
          <li innerHTML={this._sanitizer.sanitize(part11)}></li>
          <li innerHTML={this._sanitizer.sanitize(part12)}></li>
        </ul>
        {[
          {
            type: "heading",
            content: part13,
          },
          {
            type: "paragraph",
            content: part14,
          },
          {
            type: "image",
            content: null,
            url: reporter_Pic1,
          },
          {
            type: "heading",
            content: part15,
          },
          {
            type: "paragraph",
            content: part16,
          },
          {
            type: "image",
            content: null,
            url: reporter_Pic2,
          },
          {
            type: "heading",
            content: part17,
          },
          {
            type: "paragraph",
            content: part18,
          },
          {
            type: "image",
            content: null,
            url: reporter_Pic3,
          },
          {
            type: "heading",
            content: part19,
          },
          {
            type: "paragraph",
            content: part20,
          },
          {
            type: "image",
            content: null,
            url: reporter_Pic4,
          },
          {
            type: "heading",
            content: part21,
          },
          {
            type: "paragraph",
            content: part22,
          },
          {
            type: "image",
            content: null,
            url: reporter_Pic5,
          },
          {
            type: "heading",
            content: part23,
          },
          {
            type: "paragraph",
            content: part24,
          },
          {
            type: "heading",
            content: part25,
          },
          {
            type: "paragraph",
            content: part26,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
      </div>,
    ];
  }

  private _renderLanguageSwitcher(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
    } = this?.appMessages?.featureArticle_LanguageSwitcher || {};
    return [
      <img
        key="header-img-lang-switcher"
        id="header-img"
        src={LanguageSwitcherTitlePic}
        alt=""
      />,

      <div key="article-content-lang-switcher" class="article-content">
        <header id="article-header">{part1}</header>
        {[
          {
            type: "paragraph",
            content: part2,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic1,
          },
          {
            type: "heading",
            content: part3,
          },
          {
            type: "paragraph",
            content: part4,
          },
          {
            type: "paragraph",
            content: part5,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic2,
          },
          {
            type: "paragraph",
            content: part6,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic3,
          },
          {
            type: "paragraph",
            content: part7,
          },
          {
            type: "paragraph",
            content: part8,
          },
          {
            type: "paragraph",
            content: part9,
          },
          {
            type: "heading",
            content: part10,
          },
          {
            type: "paragraph",
            content: part11,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic4,
          },
          {
            type: "paragraph",
            content: part12,
          },
          {
            type: "paragraph",
            content: part13,
          },
          {
            type: "paragraph",
            content: part14,
          },
          {
            type: "paragraph",
            content: part15,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic5,
          },
          {
            type: "paragraph",
            content: part16,
          },
          {
            type: "heading",
            content: part17,
          },
          {
            type: "paragraph",
            content: part18,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic6,
          },
          {
            type: "paragraph",
            content: part19,
          },
          {
            type: "image",
            content: null,
            url: langSwitcher_Pic7,
          },
          {
            type: "paragraph",
            content: part20,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
      </div>,
    ];
  }

  private _renderCompare(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
      part23,
      part24,
    } = this?.appMessages?.featureArticle_Compare || {};
    return [
      <img
        key="header-img-lang-switcher"
        id="header-img"
        src={CompareTitlePic}
        alt=""
      />,

      <div key="article-content-compare" class="article-content">
        <header id="article-header">{part1}</header>
        {[
          {
            type: "paragraph",
            content: part2,
          },
          {
            type: "image",
            content: null,
            url: compare_Pic1,
          },
          {
            type: "paragraph",
            content: part3,
          },
          {
            type: "heading",
            content: part4,
          },
          {
            type: "paragraph",
            content: part5,
          },
          {
            type: "image",
            content: part6,
            url: compare_Pic2,
            useAsCaption: true,
          },
          {
            type: "image",
            content: part7,
            url: compare_Pic3,
            useAsCaption: true,
          },
          {
            type: "paragraph",
            content: part8,
          },
          {
            type: "heading",
            content: part9,
          },
          {
            type: "paragraph",
            content: part10,
          },
          {
            type: "image",
            content: part11,
            url: compare_Pic4,
            useAsCaption: true,
          },
          {
            type: "image",
            content: part12,
            url: compare_Pic5,
            useAsCaption: true,
          },
          {
            type: "image",
            content: part13,
            url: compare_Pic6,
            useAsCaption: true,
          },
          {
            type: "heading",
            content: part14,
          },
        ].map((blogElement) => this._blogRenderEngine(blogElement))}
        <ul class="large-width-list">
          <li innerHTML={this._sanitizer.sanitize(part15)}></li>
          {this._renderPic(compare_Pic7)}
          {this._renderPic(compare_Pic8, part16, true)}
          <li innerHTML={this._sanitizer.sanitize(part17)}></li>
          {this._renderPic(compare_Pic9)}
          {this._renderPic(compare_Pic10)}
          <li innerHTML={this._sanitizer.sanitize(part18)}></li>
          {this._renderPic(compare_Pic11)}
          {this._renderPic(compare_Pic12, part19, true)}
          {this._renderPic(compare_Pic13, part20, true)}
          <li innerHTML={this._sanitizer.sanitize(part21)}></li>
          {this._renderPic(compare_Pic14)}
          {this._renderPic(compare_Pic15, part22, true)}
          {this._renderPic(compare_Pic16, part23, true)}
          <li innerHTML={this._sanitizer.sanitize(part24)}></li>
          {this._renderPic(compare_Pic17)}
        </ul>
      </div>,
    ];
  }

  private _blogRenderEngine(blogElement: {
    type: "paragraph" | "image" | "heading" | any;
    content: string;
    url?: string;
    useAsCaption?: boolean;
  }) {
    switch (blogElement.type) {
      case "paragraph":
        return this._renderSanitizedParagraph(blogElement.content);
      case "image":
        return this._renderPic(
          blogElement.url,
          blogElement.content,
          blogElement.useAsCaption
        );
      case "heading":
        return this._renderSanitizedHeading(blogElement.content);
      default:
        return blogElement?.content;
    }
  }

  private _renderPic(
    picUrl: string,
    caption?: string,
    useAsCaption?: boolean
  ): VNode {
    return (
      <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
        <div class="newsr-image_content">
          <img
            class="newsr-image_src theming-image"
            src={picUrl}
            alt={caption}
            title={caption}
          />
        </div>
        {caption && useAsCaption && (
          <figcaption class="newsr-image_caption">{caption}</figcaption>
        )}
      </figure>
    );
  }

  private _renderSanitizedParagraph(paragraph: string): VNode {
    return <p innerHTML={this._sanitizer.sanitize(paragraph)}></p>;
  }

  private _renderSanitizedHeading(heading: string): VNode {
    return <h2 innerHTML={this._sanitizer.sanitize(heading)}></h2>;
  }
}
